import {Grid2, MenuItem} from '@mui/material';
import {RhfTextField} from 'mui-rhf-integration';
import {useFormContext} from 'react-hook-form';

const EmployeeForm = (): JSX.Element => {
    const {control} = useFormContext();
    return (
        <Grid2 size={12} sx={{p: 1}}>
            <RhfTextField
                select
                control={control}
                name='computerPreference'
                label='Computer Preference'
                sx={{
                    width: '100%',
                    backgroundColor: '#fff',
                }}
            >
                <MenuItem value='10121'>Mac</MenuItem>
                <MenuItem value='10122'>Windows</MenuItem>
            </RhfTextField>
        </Grid2>
    );
};

export default EmployeeForm;
